/** Dashboard stat / KPI → in-app routes (admin/staff operational screens). */
export const DASHBOARD_NAV = {
  liveJobs: '/dispatcher?tab=active',
  pending: '/dispatcher?tab=action',
  completion: '/reports',
  cancelRate: '/reports',
  customers: '/users?userType=customer',
  partners: '/partners',
  revenue: '/reports',
  zones: '/zones',
  transportRides: '/hubs/transport/transport/bookings',
  porterOrders: '/hubs/delivery/porter-service/bookings',
  onDemandServices: '/hubs/on_demand/home-services/bookings',
  needsAction: '/dispatcher?tab=action',
  activeJobs: '/dispatcher?tab=active',
  pendingSettlements: '/settlements',
  paymentTransactions: '/payment-transactions',
  partnerApprovals: '/partners',
  todayActivity: '/dispatcher?tab=active',
} as const;

export type DashboardNavKey = keyof typeof DASHBOARD_NAV;

/** God-view / analytics service mix keys → operational screens. */
export const DASHBOARD_SERVICE_NAV: Record<string, string> = {
  transport: DASHBOARD_NAV.transportRides,
  porter: DASHBOARD_NAV.porterOrders,
  on_demand: DASHBOARD_NAV.onDemandServices,
};

/** Role-dashboard metric widgets → operational screens. */
export const DASHBOARD_METRIC_NAV: Record<string, string> = {
  totalUsers: DASHBOARD_NAV.customers,
  totalRides: DASHBOARD_NAV.transportRides,
  completedRides: DASHBOARD_NAV.transportRides,
  totalDrivers: DASHBOARD_NAV.partners,
  totalPorterOrders: DASHBOARD_NAV.porterOrders,
  completedPorterOrders: DASHBOARD_NAV.porterOrders,
  totalOnDemandBookings: DASHBOARD_NAV.onDemandServices,
  completedOnDemandBookings: DASHBOARD_NAV.onDemandServices,
  activeOnDemandBookings: DASHBOARD_NAV.onDemandServices,
  totalRevenue: DASHBOARD_NAV.revenue,
};
